import { Dropdown } from "primereact/dropdown";
import { useManagerChangeRequest } from "../../../Hooks/Features/Overview/useManagerChangeRequest"
import CommonGrid from "../../../components/CommonCompo/CommonGrid/CommonGrid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SkeletonDataTable } from "../../Loader/Loader";
import { calculateWordsFromString } from "../../../utils/Helper";

const ManagerChangeRequest = ({ options, userData }) => {

    const { fieldValues, setFieldValues, requestManagerChange, columns, rowData } = useManagerChangeRequest({ userData });

    return (
        <div className="d-flex gap-2 h-100">
            <div className="d-flex flex-column gap-2 w30 h-100 p-3 rounded overflow-y-auto" style={{backgroundColor: "#f5f5f5"}}>
                <div>
                    <label className="mb-1 fw-semibold">Reporting Manager: </label>
                    <Dropdown options={options?.leads} optionLabel="user_display_name" filter filterInputAutoFocus placeholder="Select Reporting Manager" className="sk-input-dd" value={fieldValues?.reportingManager} onChange={(e) => setFieldValues((prev) => ({ ...prev, reportingManager: e?.target?.value }))} />
                </div>
                <div>
                    <label className="mb-1 fw-semibold">Remark: </label>
                    <textarea placeholder="Enter Remark..." className="w100 bg-white" rows={5} value={fieldValues?.remark} onChange={(e) => setFieldValues((prev) => ({ ...prev, remark: e?.target?.value }))}/>
                    {calculateWordsFromString(fieldValues?.remark) < 5 && <div>{calculateWordsFromString(fieldValues?.remark)} / 5 words</div>}
                </div>
                <div className="d-flex justify-content-end gap-1">
                    <button className="sk-btn-primary sk-btn" onClick={() => setFieldValues((prev) => ({ ...prev, reportingManager: null, remark: "" }))}> <FontAwesomeIcon icon="fa-solid fa-close" /> Reset</button>
                    {fieldValues?.loader ?
                        <button className="sk-btn-primary sk-btn bg-black text-white" style={{ width: "70px" }}><div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                            <span className="sr-only"></span>
                        </div></button> :
                        <button className="sk-btn-primary sk-btn bg-black text-white" onClick={() => requestManagerChange()}> <FontAwesomeIcon icon="fa-solid fa-paper-plane" /> Request</button>
                    }
                </div>
            </div>
            <div className="w70" style={{maxHeight: "50vh", overflowY: "auto", overflowX: "hidden"}}>
                {fieldValues?.gridLoader ?
                    <div><SkeletonDataTable numSkeletons={12} numColumns={4}/></div> :
                    <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData }]} />}
            </div>
        </div>
    )
}

export default ManagerChangeRequest